import React, {useContext, useEffect} from "react"
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Tooltip from "@amzn/meridian/tooltip";
import Select, {SelectOption} from "@amzn/meridian/select";
import Tag from "@amzn/meridian/tag";
import {injectIntl} from "react-intl";
import {getDepartStatusList, getShipmentTypeList} from "../util/EntityStatusManager";
import ExportCSV from "../exportcsv/ExportCSV";
import {getDepartDataInCSVFormat, getDepartDataInCSVFormatForIN} from "../util/ExportUtils";
import {DepartFilterContext} from "./context/DepartFilterContext";
import {DepartContext} from "./context/DepartContext";
import RefreshTimer from "../util/RefreshTimer";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import {isNotINRegionOrSSD, isNotSSDAndINRegion} from "../util/Util";

const DepartFilter = (props) => {
    const {viewModelF, dispatchF} = useContext(DepartFilterContext)
    const {viewModel} = useContext(DepartContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {spacingInset_shorthand2} = useDeviceLayout()

    const departDataConversionHandler = () => {
        if (isNotINRegionOrSSD(configViewModel.capability))
            return getDepartDataInCSVFormat(viewModel.routeList);
        else
            return getDepartDataInCSVFormatForIN(viewModel.routeList);
    }

    const isFilterSet = () => {
        let result = false;
        Object.entries(viewModelF).forEach(entry => {
            const key = entry[0];
            const values = entry[1];
            result = result || (Array.isArray(values) && values.length && key !== 'data');
        });
        return result;
    }

    const clearAllFilters = () => {
        dispatchF({type: 'REMOVE_ALL_FILTER'});
    }

    const isXPTFilterRequired = () => {
        const xptNodes = viewModelF.data.xptNodes;
        return Array.isArray(xptNodes) && xptNodes.length;
    }

    useEffect(() => {
        dispatchF({type: 'LOAD_FILTERS'});
        dispatchF({
            type: 'LOAD_XPT_NODES',
            data: {
                dispatcher: dispatchF,
                baseUrl: configViewModel.baseUrl,
                capability: configViewModel.capability,
                stationConfig: configViewModel.stationConfig
            }
        });
    }, []);

    return (
        <Column spacingInset={spacingInset_shorthand2} spacing={"none"}>
                <Row width="100%" spacingInset="none" alignmentHorizontal={"right"}>
                    <ExportCSV isLink={true} csvDataProvider={departDataConversionHandler} filePrefix={"DEPART"} />
                </Row>
            <Column width="100%" spacing={"none"}>
                <Row width="100%" wrap={"down"} spacingInset="medium small" spacing="small" backgroundColor="secondary">
                    {isXPTFilterRequired() ?
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_XPT_NODE', xptNodes: data})}
                            value={viewModelF.xptNodes}
                            size="small"
                            placeholder={props.intl.formatMessage({id: "stage.xptNodes", defaultMessage: "XPT Nodes"})}
                            width={"120px"}>
                            {[...viewModelF.data.xptNodes].sort().map(xptNode => (
                                <SelectOption key={xptNode} label={xptNode} value={xptNode} />
                            ))}
                        </Select>
                        : null
                    }
                    {isNotINRegionOrSSD(configViewModel.capability) ?
                    <Select
                        onChange={(data) => dispatchF({type: 'SELECT_DEPARTURE', Departure: data})}
                        value={viewModelF.departure}
                        size="small"
                        placeholder={props.intl.formatMessage({id: "stage.stageByTime", defaultMessage: "Stage by time"})}
                        width={"145px"}>
                        {[...viewModelF.data.departure].sort().map(departure => (
                            <SelectOption key={departure} label={"Stage by " + departure}
                                value={departure} />
                        ))}
                    </Select> : null
                    }
                    {isNotSSDAndINRegion(configViewModel.capability) ?
                    <Select
                        onChange={(data) => dispatchF({type: 'SELECT_DEPART_TIME', DepartByTime: data})}
                        value={viewModelF.departByTime}
                        size="small"
                        placeholder={props.intl.formatMessage({id: "depart.departByTime", defaultMessage: "Depart by time"})}
                        width={"145px"}>
                        {[...viewModelF.data.departByTime].map(departure => (
                            <SelectOption key={departure} label={"Depart by " + departure}
                                          value={departure} />
                        ))}
                    </Select> : null
                    }
                    {!configViewModel.stationConfig.amxl ?
                    <Select
                        onChange={(data) => dispatchF({type: 'SELECT_DRIVER_TYPE', DriverType: data})}
                        value={viewModelF.driverType}
                        size="small"
                        placeholder={props.intl.formatMessage({
                            id: "stageFilter.driverType",
                            defaultMessage: "Driver Type"
                        })}
                        width={"125px"}>
                        {[...viewModelF.data.driverType].sort().map(driverType => (
                            <SelectOption key={driverType} label={driverType} value={driverType} />
                        ))}
                    </Select> : null
                    }
                    {isNotINRegionOrSSD(configViewModel.capability) && !configViewModel.stationConfig.amxl ?
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_CLUSTER', Cluster: data})}
                            value={viewModelF.cluster}
                            size="small"
                            placeholder={props.intl.formatMessage({
                                id: "stageFilter.cluster",
                                defaultMessage: "Cluster"
                            })}
                            width={"115px"}>
                            {[...viewModelF.data.cluster].sort().map(cluster => (
                                <SelectOption key={cluster} label={cluster} value={cluster}/>
                            ))}
                        </Select> : null
                    }
                    {!configViewModel.stationConfig.amxl ?
                    <Select
                        onChange={(data) => dispatchF({type: 'SELECT_STATUS', status: data})}
                        value={viewModelF.status}
                        size="small"
                        placeholder={props.intl.formatMessage({id: "cartInfo.status", defaultMessage: "Status"})}
                        width={"120px"}>
                        {getDepartStatusList(configViewModel.capability).map(status => (
                            <SelectOption key={status} label={status} value={status} />
                        ))}
                    </Select> : null}
                    {configViewModel.stationConfig.amxl ?
                    <Select
                        onChange={(data) => dispatchF({type: 'SELECT_DRIVER_TYPE', DriverType: data})}
                        value={viewModelF.driverType}
                        size="small"
                        placeholder={props.intl.formatMessage({
                            id: "departFilter.routeType",
                            defaultMessage: "Route Type"
                        })}
                        width={"125px"}>
                        {[...viewModelF.data.driverType].sort().map(driverType => (
                            <SelectOption key={driverType} label={driverType} value={driverType} />
                        ))}
                    </Select> : null}
                    {configViewModel.stationConfig.amxl ? <Tooltip position="end" title="Shipment Type filter is currently not supported.">
                        <Select
                            onChange={(data) => dispatchF({type: 'SELECT_STATUS', status: data})}
                            value={viewModelF.status}
                            size="small"
                            disabled={true}
                            placeholder={props.intl.formatMessage({id: "departFilter.shipmentType", defaultMessage: "Shipment Type"})}
                            width={"160px"}>
                            {getShipmentTypeList().map(type => (
                                <SelectOption key={type} label={type} value={type} />
                            ))}
                        </Select>
                    </Tooltip>: null}
                </Row>
            </Column>
            <Row width="100%" spacingInset="small none none none">
                <Row spacing={"small"}>
                    {Object.entries(viewModelF).map(entry => {
                        const key = entry[0]
                        const values = entry[1]
                        return (
                            (Array.isArray(values) && key !== 'data') ? values.map(value => {
                                return <Tag key={value} type="theme"
                                    onClose={() => dispatchF({
                                        type: 'REMOVE_FILTER',
                                        data: {key, value}
                                    })}>{value}</Tag>
                            }) : null
                        )
                    })}
                    {isFilterSet() ? <Link onClick={clearAllFilters} type="secondary">Clear all</Link> : null}
                </Row>
            </Row>

            <Row spacingInset="small none">
                <RefreshTimer deps={[viewModel.lastUpdated]} lastUpdated={viewModel.lastUpdated} />
            </Row>
        </Column>
    )
}

export default injectIntl(DepartFilter)



// WEBPACK FOOTER //
// ./src/components/depart/DepartFilter.js